/**
 * Saved Routes mobile map (phone-sized viewports only).
 * Set true when in-app routing (Mapbox / Google) ships on mobile.
 */
export const SAVED_ROUTES_SHOW_MOBILE_MAP = false;

/** Phone viewport: matches LeadsMobileMapView — tablets (768px+) keep the map. */
export function shouldShowSavedRoutesMap(isPhoneViewport) {
  return SAVED_ROUTES_SHOW_MOBILE_MAP || !isPhoneViewport;
}
